import React from 'react';

interface IconArrowLeftProps extends React.SVGProps<SVGSVGElement> {
}

const IconArrowLeft: React.FC<IconArrowLeftProps> = (props) => {
    return (
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M1 17L9 9L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    );
};

export default IconArrowLeft;